<div>
    <h5 [class.text-danger]="planningMaterialsArray.invalid">Materialen</h5>
</div>
<table class="table table-center" [class.table-add-row]="!isFormDisabled()" [class.table-last-col]="!isFormDisabled()">
    <tr>
        <th>Materiaal</th>
        <th>Toevoegingen</th>
        <th>Type</th>
        <th>Leverancier</th>
        <th>Kleur</th>
        <th colspan="2">Hoeveelheid</th>
        @if (!isFormDisabled()) {
            <th></th>
        }
    </tr>
    @for (materialControl of planningMaterialsArray.controls; track $index) {
        @let material = materialControl.get('material')?.value;
        @let width = material | materialProperty: 'width';
        @let optionals = material | materialDetails: true;
        @let consumption = material | materialProperty: 'consumption';
        @let quantityUnit = material | materialProperty: 'quantity_unit';

        <tr [formGroup]="materialControl">
            <td>
                {{ material | materialProperty: 'name' }}

                @if (width) {
                    &nbsp;<small class="text-muted">({{ width }} cm)</small>
                }

                @if (consumption) {
                    <small>{{ consumption }}{{ quantityUnit }}</small>
                }
            </td>
            <td>
                @if (optionals) {
                    <small class="text-muted">
                        {{ optionals }}
                    </small>
                }
            </td>
            <td>
                {{ material | materialProperty: 'type' }}
            </td>
            <td>
                {{ material | materialProperty: 'supplier' }}
            </td>
            <td>
                <div class="d-flex align-items-center">
                    @let colorName = material | materialProperty: 'colorName';
                    @let color = material | materialProperty: 'color';
                    @if (colorName) {
                        <span
                            class="color-circle-small me-2"
                            [class.transparent]="colorName === 'transparant'"
                            [style.background]="color"></span>
                    }

                    <span class="flex-grow-1">{{ colorName }}</span>

                    <span>{{ material | materialProperty: 'colorRal' }}</span>
                </div>
            </td>
            <td (click)="quantityInput.focus()">
                <input
                    class="text-right"
                    #quantityInput
                    [decimalInput]="3"
                    matInput
                    type="text"
                    formControlName="quantity"
                    placeholder="Hoeveelheid"
                    min="0"
                    appDecimalInput
                    required />
            </td>
            <td>
                {{ material | materialProperty: 'quantity_unit' }}
            </td>
            @if (!isFormDisabled()) {
                <td>
                    <button
                        class="icon-button-medium"
                        (click)="removeMaterial($index)"
                        color="warn"
                        mat-icon-button
                        matTooltip="Verwijder"
                        matTooltipClass="warn-background"
                        matTooltipPosition="right"
                        tabindex="-1">
                        <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
                    </button>
                </td>
            }
        </tr>
    }

    @if (!isFormDisabled()) {
        <tr>
            <td [colSpan]="7">
                <button class="w-100" (click)="openAddModal()" mat-button color="primary">
                    Toevoegen <i class="fas fa-plus"></i>
                </button>
            </td>
        </tr>
    }
</table>

<ng-template #materialSelectionDialog>
    <h2 mat-dialog-title>Selecteer materiaal</h2>

    <mat-dialog-content>
        <mat-form-field class="w-100 pt-1" appearance="outline">
            <mat-label>Zoeken</mat-label>
            <input [formControl]="searchControl" matInput placeholder="Zoek op naam" />
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <cdk-virtual-scroll-viewport class="material-viewport" itemSize="72">
            <mat-selection-list class="material-list" [multiple]="false" [hideSingleSelectionIndicator]="true">
                @for (material of filteredMaterials; track material.id) {
                    @let details = material | materialDetails;
                    @let optionals = material | materialDetails: true;
                    @let width = material | materialProperty: 'width';
                    @let supplier = material | materialProperty: 'supplier';
                    @let consumption = material | materialProperty: 'consumption';
                    @let quantityUnit = material | materialProperty: 'quantity_unit';

                    <mat-list-option
                        [ngStyle]="optionals ? { height: '84px' } : { height: '72px' }"
                        (click)="selectMaterial(material)">
                        @let colorName = material | materialProperty: 'colorName';
                        @let color = material | materialProperty: 'color';

                        @if (colorName) {
                            <div
                                class="color-circle"
                                [class.transparent]="colorName === 'transparant'"
                                [style.background]="color"
                                matListItemAvatar></div>
                        } @else {
                            <div class="d-inline-block size-40" matListItemAvatar></div>
                        }

                        <div class="d-flex pt-2" matListItemTitle>
                            <div class="flex-fill">
                                {{ material.name }}
                                {{ consumption }}{{ quantityUnit }}
                            </div>
                            <div class="fit-content">
                                {{ supplier }}
                            </div>
                        </div>

                        <div class="d-flex pt-2" matListItemLine>
                            <div class="d-flex flex-column w-100">
                                @if (details) {
                                    {{ details }}
                                }
                                @if (width) {
                                    &nbsp;<small class="text-muted">({{ width }} cm)</small>
                                }
                                @if (optionals) {
                                    <div class="flex-ellipsis" [style.max-width.px]="300">
                                        {{ optionals }}
                                    </div>
                                }
                            </div>
                            <div>
                                <i class="text-muted">{{ material | materialProperty: 'usage' }}</i>
                            </div>
                        </div>
                    </mat-list-option>
                }
            </mat-selection-list>
        </cdk-virtual-scroll-viewport>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Annuleren</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #optionalSelectionDialog>
    <h2 mat-dialog-title>Voeg optioneel materiaal toe</h2>

    <mat-dialog-content>
        @for (group of groupedOptionals; track group.materialType.id) {
            <h4 class="optionals-group">{{ group.materialType.name }}</h4>

            @if (group.materialType.single) {
                <mat-radio-group
                    [value]="selectedOptionalsMap.get(group.materialType.id) ?? null"
                    (change)="selectedOptionalsMap.set(group.materialType.id, $event.value)">
                    @if (group.optional) {
                        <mat-radio-button [value]="null">
                            <span>Geen</span>
                        </mat-radio-button>
                    }
                    @for (raw of group.rawMaterials; track raw.id) {
                        <mat-radio-button [value]="raw">
                            <span>{{ raw.name }}</span>
                            <small class="text-muted ms-1">{{ raw.supplier?.name }}</small>
                            @if (raw.pivot?.consumption ?? raw.consumption) {
                                <small class="text-muted ms-1">
                                    {{ raw.pivot?.consumption ?? raw.consumption }} {{ raw.consumption_type?.name }}
                                </small>
                            }
                        </mat-radio-button>
                    }
                </mat-radio-group>
            } @else {
                @for (raw of group.rawMaterials; track raw.id) {
                    <div class="optional-checkbox-row">
                        <mat-checkbox
                            [checked]="isSelectedCheckbox(group.materialType.id, raw)"
                            (change)="toggleCheckbox(group.materialType.id, raw)">
                            <span>{{ raw.name }}</span>
                            @if (raw.material_type?.name !== raw.name) {
                                <small class="text-muted ms-1">{{ raw.material_type?.name }}</small>
                            }
                            <small class="text-muted ms-1">{{ raw.supplier?.name }}</small>
                            @if (raw.pivot?.consumption ?? raw.consumption) {
                                <small class="text-muted ms-1">
                                    {{ raw.pivot?.consumption ?? raw.consumption }} {{ raw.consumption_type?.name }}
                                </small>
                            }
                        </mat-checkbox>
                    </div>
                }
            }
        }
    </mat-dialog-content>

    <mat-dialog-actions class="justify-content-between">
        <button mat-button mat-dialog-close>Annuleren</button>

        <button
            [disabled]="!isOptionalSelectionValid()"
            (click)="selectOptionalMaterial(selectedMaterial)"
            mat-button
            color="primary">
            Opslaan
        </button>
    </mat-dialog-actions>
</ng-template>
